import { render, staticRenderFns } from "./StoreBalance.vue?vue&type=template&id=fd07cdc4"
import script from "./StoreBalance.vue?vue&type=script&lang=js"
export * from "./StoreBalance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports